import React, { useEffect, useState } from "react";
import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";
import Separator from "../../../../Components/Separator";
import { CommonButton } from "../../../../common/CommonButton";
import { fetchUserConnectionStatus } from "../../../../services/stream";
import { getLoginData } from "../../../../utility/AppStoreData";
import { developUrl } from "../../../../utility/Index";

const clientId =
  "618873677057-ds676sbndgl34njjum4vo1d20snkqjeu.apps.googleusercontent.com";
const redirectUri = `${developUrl}/settings?tab=streamSettings`;
const scope =
  "https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/youtube.force-ssl";

export const redirectToYouTubeOAuth = () => {
  const authUrl = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&response_type=code&scope=${encodeURIComponent(
    scope
  )}&access_type=offline&prompt=consent&include_granted_scopes=true`;

  window.location.href = authUrl;
};

const StreamingAccountModal = ({ showPopup, closePopup, image, connected }) => {
  const [loading, setLoading] = useState(false);
  const [platformStatus, setPlatformStatus] = useState("Not connected");
  const [accessToken, setAccessToken] = useState("");
  const deviceSize = useDeviceSize();

  useEffect(() => {
    const fetchAccessToken = async () => {
      try {
        const loginData = await getLoginData();
        setAccessToken(loginData.AccessToken);
      } catch (error) {
        console.error("Error fetching login data:", error);
      }
    };

    fetchAccessToken();
  }, [showPopup]);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!accessToken || connected === true) return;
      setLoading(true);
      try {
        const response = await fetchUserConnectionStatus(accessToken);
        if (response.statusCode === 200) {
          setPlatformStatus(response.body.YouTube);
        } else {
          setPlatformStatus("Not connected");
        }
      } catch (error) {
        console.error("Error fetching platform status:", error);
        setPlatformStatus("Error fetching status");
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [showPopup, accessToken, connected]);

  const handleConnect = async () => {
    setLoading(true);
    try {
      redirectToYouTubeOAuth();
    } catch (error) {
      console.error("Error during connection:", error);
      setPlatformStatus("Failed to connect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      transparent={true}
      visible={showPopup}
      onRequestClose={closePopup}
      animationType="fade"
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0, 0, 0, 0.76)",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <View
          style={{
            backgroundColor: AppColors.black_121212,
            padding: 20,
            borderRadius: 10,
            width:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 300
                : "auto",
            alignItems: "center",
            borderWidth: 1,
            borderColor: AppColors.gray_9F9F9F,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 15,
              alignItems: "center",
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_16
                  : AppFontStyle.BOLD_ANYBODY_20,
                { flex: 1 },
              ]}
            >
              Connect To Your Streaming Account
            </Text>
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
              }}
              onPress={closePopup}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 35,
                  width: 35,
                }}
              />
            </TouchableOpacity>
          </View>
          <Separator
            color={AppColors.appBlackColor_1e1e1e}
            height={2}
            marginTop={10}
            marginBottom={10}
            marginHorizontal={0}
          />
          <View
            style={{
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 0
                  : 20,
            }}
          >
            <View style={{ marginBottom: 10, width: "100%" }}>
              <Text
                style={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.REGULAR_ANYBODY_16
                    : AppFontStyle.REGULAR_ANYBODY_20
                }
              >
                Platform
              </Text>
            </View>

            <View
              style={{
                marginBottom: 20,
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 250
                    : "100%",
                height:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? "auto"
                    : 166,
                padding: 6,
                backgroundColor: AppColors.appBlackColor_1e1e1e,
                borderRadius: 10,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Image
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 200
                      : 382,
                  height: 85.28,
                  resizeMode: "contain",
                }}
                source={image}
              />
            </View>
            <View style={{ width: "100%", alignItems: "flex-end" }}>
              <CommonButton
                buttonStyle={{
                  backgroundColor:
                    platformStatus === "Connected"
                      ? AppColors.appGreenColor_51AF07
                      : loading
                      ? AppColors.appViolentColor_6D08C3
                      : AppColors.appViolentColor_6D08C3,
                  paddingVertical: 12,
                  paddingHorizontal: 24,
                  borderRadius: 5,
                  boxShadow: 0,
                  width: 212,
                }}
                textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
                title={
                  platformStatus === "Connected"
                    ? "Connected"
                    : loading
                    ? "Connecting..."
                    : "Connect"
                }
                onTap={handleConnect}
                disabled={loading || platformStatus === "Connected"}
                disabledCustomStyle={{
                  opacity: platformStatus === "Connected" ? 1 : 0.5,
                }}
              />
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default StreamingAccountModal;
